import { render, staticRenderFns } from "./serviceAndPick.vue?vue&type=template&id=9348a20c&scoped=true&"
import script from "./serviceAndPick.vue?vue&type=script&lang=js&"
export * from "./serviceAndPick.vue?vue&type=script&lang=js&"
import style0 from "./serviceAndPick.vue?vue&type=style&index=0&id=9348a20c&prod&scoped=true&lang=scss&"
import style1 from "./serviceAndPick.vue?vue&type=style&index=1&id=9348a20c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9348a20c",
  null
  
)

export default component.exports